import FullScreenLoad from "@amplio-common/components/FullScreenLoad";

export default FullScreenLoad;

